import { ICON_MAP } from './iconMap'

export const getFieldType = (type: string, code: string) => {
  // if (code === 'gender' && type === 'toggle') {
  //   return 'radioStepper'
  // }
  return type
}

export const digitalKycSteps = [
  {
    title: 'E- KYC',
    subTitle: 'Online Aadhar enabled verification',
    icon: ICON_MAP.APPLICATION_DONE_OUTLINED,
  },
  {
    title: 'Net-banking/Debit Card Verification',
    subTitle: 'Online verification via Net-banking/Debit Card',
    icon: ICON_MAP.WORLD_OUTLINED,
  },
]

export const radioButtonDescription = {
  PL_IS_PERMANENT_ADDRESS_SAME_AS_CURRENT_ADDRESS: [
    {
      code: 'Yes',
      description: 'Permanent Address is same as Current Address',
    },
    {
      code: 'No',
      description:
        'Permanent Address is different from my Current Address, and the Current Address is stated below',
    },
  ],
  IS_PERMANENT_ADDRESS_SAME_AS_CURRENT_ADDRESS: [
    {
      code: 'YES',
      description: 'My Aadhar address is same as current address.',
    },
    {
      code: 'NO',
      description:
        'My Aadhar address is different from my current address, and I hereby self-declare my Aadhar address as stated below',
    },
  ],
  income_verification: [
    {
      code: 'ACCOUNT_AGGREGATOR',
      description: 'Share details using an RBI licensed process',
      recommended: true,
      showAccountAggregatorBottomsheet: true,
    },
    {
      code: 'NET_BANKING',
      description: 'Share your details using your bank account',
    },
  ],
}

export const redirectionStates = [
  'CC_ETB_FLOW',
  'LNT_LINK_REDIRECTION',
  'HDFC_CC_RECOMMENDATION_FLOW',
  'HDFC_CC_IPA_NET_BANKING_LOGIN',
  'HDFC_CC_IPA_PERFIOUS_LOGIN',
  'HDFC_CC_ETB_IDCOMM_NET_BANKING_LOGIN',
  'HDFC_CC_ETB_EKYC_IDCOMM_DIGITAL_KYC',
  'HDFC_CC_ETB_EKYC_IDCOMM_BIOMETRIC_NET_BANKING_LOGIN',
  'HDFC_CC_ETB_EKYC_IDCOMM_NET_BANKING_LOGIN',
  'HDFC_CC_ETB_EKYC_VKYC_IDCOM_NET_BANKING_LOGIN',
  'HDFC_CC_ETB_EKYC_VKYC_IDCOM_VIDEO_KYC',
  'HDFC_CC_NTB_EKYC_DIGITAL_KYC',
  'HDFC_CC_ETB_NTB_IN_PERSON_KYC_FLOW',
]

export const radioButtonMessage = {
  IS_PERMANENT_ADDRESS_SAME_AS_CURRENT_ADDRESS: {
    text: 'The card will be dispatched to your current address.',
    icon: 'DELIVERY_TRUCK',
  },
}

export const radioStepperRecommendation = {
  ETB_DIFFERENT_ADDRESS_KYC_MODE: {
    recommended: 'DIGITAL_KYC',
    DIGITAL_KYC: [
      {
        title: 'E- KYC',
        subTitle: 'Online Aadhar enabled verification',
        icon: ICON_MAP.APPLICATION_DONE_OUTLINED,
      },
      // {
      //   title: 'Video KYC',
      //   subTitle: 'Online Video KYC using phone camera',
      //   icon: ICON_MAP.WORLD_OUTLINED,
      // },
      {
        title: 'Net-banking/Debit Card Verification',
        subTitle: 'Online verification via Net-banking/Debit Card',
        icon: ICON_MAP.WORLD_OUTLINED,
      },
    ],
    BIOMETRIC_KYC: [
      // {
      //   title: 'Net-banking/Debit Card Verification',
      //   subTitle: 'Online verification via Net-banking/Debit Card',
      //   icon: ICON_MAP.WORLD_OUTLINED,
      // },
      {
        title: 'In-Person KYC',
        subTitle:
          'Bank authorised representative will visit you for Aadhaar KYC using Biometric device.',
        icon: ICON_MAP.USER_VERIFIED_GREY,
      },
    ],
  },
  HDFC_CC_NTB_EKYC_FLOW_FORM_FIELD: {
    recommended: 'DIGITAL_KYC',
    DIGITAL_KYC: [
      {
        title: 'E- KYC',
        subTitle: 'Online Aadhar enabled verification',
        icon: ICON_MAP.APPLICATION_DONE_OUTLINED,
      },
      {
        title: 'Video KYC',
        subTitle: 'Online Video KYC using phone camera',
        icon: ICON_MAP.WORLD_OUTLINED,
      },
    ],
    BIOMETRIC_KYC: [
      {
        title: 'In-Person KYC',
        subTitle:
          'Bank authorised representative will visit you for Aadhaar KYC using Biometric device.',
        icon: ICON_MAP.USER_VERIFIED_GREY,
      },
    ],
  },
  ETB_SAME_ADDRESS_KYC_MODE: {
    recommended: 'Verification',
    Verification: [
      {
        title: 'Net-banking/Debit Card Verification',
        subTitle: 'Online verification via Net-banking/Debit Card',
        icon: ICON_MAP.WORLD_OUTLINED,
      },
    ],
  },
}
